// removed by extract-text-webpack-plugin
module.exports = {"box":"box_CommonFooter","line":"line_CommonFooter","copyright":"copyright_CommonFooter","link":"link_CommonFooter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommonFooter/CommonFooter.scss
// module id = 288
// module chunks = 0